module.exports = __webpack_public_path__ + "static/img/hk_logo.2646ca9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hk_logo.png
// module id = 8Lvc
// module chunks = 1